var _path, _path2, _path3, _path4, _path5, _g, _circle, _g2, _circle2, _g3, _circle3, _path6, _path7, _g4, _circle4, _g5, _circle5, _g6, _circle6, _path8, _path9, _g7, _circle7, _g8, _circle8, _g9, _circle9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 321,
    viewBox: "0 0 321 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_2235)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.167 0.329555H178.107L319.926 219.018L304.173 249.687H16.8392L1.14636 219.157L143.167 0.329555Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.04 132.444C178.04 140.417 182.49 147.701 189.581 151.346C244.776 179.717 320.198 218.484 320.198 218.484L304.159 249.687L170.224 180.844C164.12 177.706 156.877 177.706 150.773 180.844L16.8376 249.687L0.798828 218.484C0.798828 218.484 76.2207 179.717 131.415 151.346C138.507 147.701 142.956 140.417 142.956 132.444C142.956 76.1705 142.956 0.191406 142.956 0.191406H178.04C178.04 0.191406 178.04 76.1705 178.04 132.444Z",
    fill: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.221 160.443C172.221 153.882 166.901 148.563 160.34 148.563C153.778 148.563 148.459 153.882 148.459 160.443C148.459 167.005 153.778 172.324 160.34 172.324C166.901 172.324 172.221 167.005 172.221 160.443Z",
    fill: "#CACACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.824 132.428V0.191406H177.908V132.428C177.908 139.6 172.094 145.414 164.922 145.414H160.366H155.81C148.638 145.414 142.824 139.6 142.824 132.428Z",
    fill: "#CACACA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.377 0.744V132.428C143.377 139.295 148.943 144.861 155.81 144.861H164.922C171.789 144.861 177.356 139.295 177.356 132.428V0.744H143.377ZM142.824 132.428C142.824 139.6 148.638 145.414 155.81 145.414H164.922C172.094 145.414 177.908 139.6 177.908 132.428V0.191406H142.824V132.428Z",
    fill: "#8C8C8C",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160.23,
    cy: 23.6767,
    r: 4.14445,
    fill: "#BBBBBB"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160.23,
    cy: 23.6767,
    r: 3.73001,
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160.23,
    cy: 54.0693,
    r: 4.14445,
    fill: "#BBBBBB"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.23,
    cy: 54.0693,
    r: 3.73001,
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160.23,
    cy: 76.1728,
    r: 4.14445,
    fill: "#BBBBBB"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.23,
    cy: 76.1728,
    r: 3.73001,
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.504 185.449L16.5195 249.153L0.641335 217.868L125.586 154.184C131.984 150.923 139.814 153.473 143.063 159.877L147.187 168.002C150.429 174.39 147.886 182.196 141.504 185.449Z",
    fill: "#CACACA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7618 248.41L141.253 184.957C147.364 181.842 149.798 174.368 146.694 168.252L142.571 160.127C139.459 153.996 131.963 151.554 125.837 154.676L1.38376 218.11L16.7618 248.41ZM141.504 185.449C147.886 182.196 150.429 174.39 147.187 168.002L143.063 159.877C139.814 153.473 131.984 150.923 125.586 154.184L0.641335 217.868L16.5195 249.153L141.504 185.449Z",
    fill: "#8C8C8C",
    fillOpacity: 0.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5837,
    cy: 223.003,
    r: 4.14445,
    transform: "rotate(-116.909 29.5837 223.003)",
    fill: "#BBBBBB"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5837,
    cy: 223.003,
    r: 3.73001,
    transform: "rotate(-116.909 29.5837 223.003)",
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.6853,
    cy: 209.248,
    r: 4.14445,
    transform: "rotate(-116.909 56.6853 209.248)",
    fill: "#BBBBBB"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.6853,
    cy: 209.248,
    r: 3.73001,
    transform: "rotate(-116.909 56.6853 209.248)",
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.3962,
    cy: 199.244,
    r: 4.14445,
    transform: "rotate(-116.909 76.3962 199.244)",
    fill: "#BBBBBB"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.3962,
    cy: 199.244,
    r: 3.73001,
    transform: "rotate(-116.909 76.3962 199.244)",
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.246 185.451L304.652 249.153L320.531 217.868L195.133 154.17C188.737 150.921 180.918 153.474 177.672 159.871L173.548 167.996C170.303 174.39 172.854 182.204 179.246 185.451Z",
    fill: "#CACACA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.41 248.41L179.497 184.958C173.376 181.849 170.933 174.368 174.04 168.246L178.164 160.121C181.273 153.996 188.759 151.552 194.882 154.663L319.788 218.11L304.41 248.41ZM179.246 185.451C172.854 182.204 170.303 174.39 173.548 167.996L177.672 159.871C180.918 153.474 188.737 150.921 195.133 154.17L320.531 217.868L304.652 249.153L179.246 185.451Z",
    fill: "#8C8C8C",
    fillOpacity: 0.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.14445,
    transform: "matrix(0.452576 -0.891726 -0.891726 -0.452576 291.586 223.003)",
    fill: "#BBBBBB"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 3.73001,
    transform: "matrix(0.452576 -0.891726 -0.891726 -0.452576 291.586 223.003)",
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.14445,
    transform: "matrix(0.452576 -0.891726 -0.891726 -0.452576 264.485 209.248)",
    fill: "#BBBBBB"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 3.73001,
    transform: "matrix(0.452576 -0.891726 -0.891726 -0.452576 264.485 209.248)",
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_621_2235)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.14445,
    transform: "matrix(0.452576 -0.891726 -0.891726 -0.452576 244.774 199.244)",
    fill: "#BBBBBB"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 3.73001,
    transform: "matrix(0.452576 -0.891726 -0.891726 -0.452576 244.774 199.244)",
    stroke: "#BFBFBF",
    strokeWidth: 0.828891
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.184 160.327C216.184 191.109 191.231 216.062 160.449 216.062C129.667 216.062 104.713 191.109 104.713 160.327C104.713 129.545 129.667 104.591 160.449 104.591C191.231 104.591 216.184 129.545 216.184 160.327Z",
    fill: "url(#paint0_linear_621_2235)",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.449 208.05C186.805 208.05 208.172 186.683 208.172 160.327C208.172 133.97 186.805 112.603 160.449 112.603C134.092 112.603 112.725 133.97 112.725 160.327C112.725 186.683 134.092 208.05 160.449 208.05ZM160.449 216.062C191.231 216.062 216.184 191.109 216.184 160.327C216.184 129.545 191.231 104.591 160.449 104.591C129.667 104.591 104.713 129.545 104.713 160.327C104.713 191.109 129.667 216.062 160.449 216.062Z",
    fill: "#BFBFBF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.725 160.327C112.725 186.683 134.092 208.05 160.449 208.05C186.805 208.05 208.172 186.683 208.172 160.327C208.172 133.97 186.805 112.603 160.449 112.603C134.092 112.603 112.725 133.97 112.725 160.327ZM104.713 160.327C104.713 191.109 129.667 216.062 160.449 216.062C191.231 216.062 216.184 191.109 216.184 160.327C216.184 129.545 191.231 104.591 160.449 104.591C129.667 104.591 104.713 129.545 104.713 160.327Z",
    fill: "url(#paint1_linear_621_2235)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_621_2235",
    x: 156.086,
    y: 19.5322,
    width: 9.39425,
    height: 9.39425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_621_2235",
    x: 156.086,
    y: 49.9248,
    width: 9.39425,
    height: 9.39425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_621_2235",
    x: 156.086,
    y: 72.0283,
    width: 9.39425,
    height: 9.39425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_621_2235",
    x: 25.4375,
    y: 218.857,
    width: 9.3962,
    height: 9.3962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_621_2235",
    x: 52.5391,
    y: 205.103,
    width: 9.3962,
    height: 9.3962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_621_2235",
    x: 72.25,
    y: 195.099,
    width: 9.3962,
    height: 9.3962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_621_2235",
    x: 287.441,
    y: 218.857,
    width: 9.3962,
    height: 9.3962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_621_2235",
    x: 260.34,
    y: 205.103,
    width: 9.3962,
    height: 9.3962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_621_2235",
    x: 240.629,
    y: 195.099,
    width: 9.3962,
    height: 9.3962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.65778,
    dy: 1.10519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_2235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_2235",
    x1: 172.464,
    y1: 113.883,
    x2: 141.795,
    y2: 207.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#1A1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_2235",
    x1: 204.135,
    y1: 125.921,
    x2: 125.805,
    y2: 204.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184482,
    stopColor: "#8C8C8C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389762,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.530993,
    stopColor: "#8C8C8C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654029,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787145,
    stopColor: "#8C8C8C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915142,
    stopColor: "#8C8C8C",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_2235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320.288,
    height: 320.288,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpool);
export default __webpack_public_path__ + "static/media/Spool.3e1b2f10981e9bde33aecbea398c1728.svg";
export { ForwardRef as ReactComponent };